module.exports = __webpack_public_path__ + "static/media/Short-term-goal.235a2929.svg";